import { render } from "./Header.vue?vue&type=template&id=8b73f530&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=8b73f530&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1672060877/src/vivamo-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b73f530"]])

export default __exports__